import Routes from './SCBZ/SCBZRoutes';

const ApiClient = Routes;

export default ApiClient;
